import React from 'react'
import { PaycodesCombinationTable } from  'components/table/paycodes_combination/PaycodesCombinationTable'

const PaycodeCombinations = () => {
    return (
        <>
            <PaycodesCombinationTable />
        </>

    )
}

export { PaycodeCombinations }